import React from 'react';

import './style.css';

export const LoadingOverlay = ({ loading, children }) => {
  if (loading)
    return (
      <div className="content">
        <div className="overlay" />
        <div className="spinner">
          <div className="bounce1" />
          <div className="bounce2" />
          <div className="bounce3" />
        </div>
        {children}
      </div>
    );
  else return children;
};

export default LoadingOverlay;
